<section class="gallery">
  <div
    class="show__item"
    [ngStyle]="{ height: images.length > 1 ? '90%' : '100%' }"
  >
  <img
      class="show__item__image mainImgBg"
      (click)="lightbox()"
      [src]="images[activeImageIndex.value]"
    />
    <img
      class="show__item__image mainImg"
      (click)="lightbox()"
      [src]="images[activeImageIndex.value]"
    />

    <!-- lightbox container hidden with CSS -->
    <div
      class="lightbox"
      (click)="lightbox()"
      [ngClass]="{ active: activeLightbox.value }"
    >
      <div class="lightbox-action">
        <div class="lightbox-index" *ngIf="images.length > 1">
          {{ activeImageIndex.value + 1 }} / {{ images.length }}
        </div>
        <button (click)="prevImage($event)" *ngIf="images.length > 1">
          <i class="fa-solid fa-backward"></i>
        </button>
        <button (click)="nextImage($event)" *ngIf="images.length > 1">
          <i class="fa-solid fa-forward"></i>
        </button>
        <button>
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <span
        style="background-image: url('{{ images[activeImageIndex.value] }}')"
      ></span>
    </div>

    <!-- <img
      class="show__item__image"
      alt=""
      id="show__item__image"
      [src]="images[activeImageIndex.value]"
    /> -->
  </div>
  <div class="gallery__list" *ngIf="images.length > 1">
    <div
      class="gallery__item"
      [ngClass]="{ active: i === activeImageIndex.value, isMobile: isMobile }"
      *ngFor="let image of images; let i = index"
      (click)="changeImage(i)"
    >
      <img class="gallery__item__image" [src]="image" alt="" />
    </div>
  </div>
</section>
